import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=b3c6a73a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c6a73a')) {
      api.createRecord('b3c6a73a', component.options)
    } else {
      api.reload('b3c6a73a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=b3c6a73a&", function () {
      api.rerender('b3c6a73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jFQrrib2pgoc/JS/comp/ErrorMessage.vue"
export default component.exports